import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"

import "./list.vue?vue&type=style&index=0&id=1a41f7e4&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a41f7e4"]])

export default __exports__